export default __webpack_public_path__ + "static/media/factor_item_5.bc7e9038.png";